const EMPTY_RATES = Object.freeze({});

export const selectLaborClassificationsState = (state) => state.laborClassifications;

export const selectAllLaborClassifications = (state) => {
  const { byId, allIds } = state.laborClassifications;
  return allIds.map((id) => byId[id]).filter(Boolean);
};

export const selectAllActiveLaborClassifications = (state) =>
  selectAllLaborClassifications(state).filter((lc) => !lc.isDeleted);

export const selectLaborClassificationById = (state, id) =>
  id ? state.laborClassifications.byId[id] || null : null;

export const selectLaborClassificationName = (state, id) =>
  selectLaborClassificationById(state, id)?.name || '';

export const selectProjectRates = (state, projectId) =>
  (projectId && state.laborClassifications.perProjectRates[projectId]) || EMPTY_RATES;

export const selectProjectRate = (state, projectId, lcId) => {
  if (!projectId || !lcId) return undefined;
  return state.laborClassifications.perProjectRates[projectId]?.[lcId];
};

export const selectIsProjectFetched = (state, projectId) =>
  !!state.laborClassifications.perProjectFetched[projectId];

export const selectResolvedPairRate = (state, { sheet, pair }) => {
  if (!sheet || !pair) return undefined;
  const lcId = pair.laborClassificationId || sheet.defaultLaborClassificationId;
  if (!lcId) return undefined;
  return selectProjectRate(state, sheet.projectId, lcId);
};

export const selectIsBootstrapped = (state) => !!state.laborClassifications.bootstrapped;
